import {
  TOGGLE_WIDGET,
  TOGGLE_MODAL,
  SET_INPUT_DATA,
  SET_INPUT_DATA_OFFER,
  SET_CONTRACTUAL_CATEGORY,
  SET_CONTRACTUAL_CATEGORY_OFFER,
  TOGGLE_LOADING,
  GET_LOGIC_RESPONSE,
  GET_LOGIC_OFFER_RESPONSE,
  CHECK_SUSTAINABILITY_REQUEST,
  CHECK_SUSTAINABILITY_OFFER_REQUEST,
  CHECK_SUSTAINABILITY_RESPONSE,
  CHECK_SUSTAINABILITY_OFFER_RESPONSE,
  SET_SUSTAINABILITY_SELECTED,
  RESET_DATA,
  RESET_OFFER_DATA,
  UPDATE_PROPOSAL,
  SAVE_QUOTATION,
} from './constants';

import queryString from 'query-string';

export function openWidget() {
  return {
    type: TOGGLE_WIDGET,
    isOpen: true
  };
}

export function closeWidget() {
  return {
    type: TOGGLE_WIDGET,
    isOpen: false
  };
}

export function openModal() {
  return {
    type: TOGGLE_MODAL,
    isOpen: true
  };
}

export function closeModal() {
  return {
    type: TOGGLE_MODAL,
    isOpen: false
  };
}

export function setContractualCategory(contractualCategory) {
  return {
    type: SET_CONTRACTUAL_CATEGORY,
    contractualCategory
  };
}

export function setContractualCategoryOffer(contractualCategory) {
  return {
    type: SET_CONTRACTUAL_CATEGORY_OFFER,
    contractualCategory
  };
}

export function setInputData(inputData) {
  return {
    type: SET_INPUT_DATA,
    inputData
  };
}

export function setInputDataOffer(inputData) {
  return {
    type: SET_INPUT_DATA_OFFER,
    inputData
  };
}

export function toggleLoading(isLoading) {
  return {
    type: TOGGLE_LOADING,
    isLoading
  };
}

export function receiveLogic(logicData) {
  return {
    type: GET_LOGIC_RESPONSE,
    logicData,
  };
}

export function receiveOfferLogic(logicData) {
  return {
    type: GET_LOGIC_OFFER_RESPONSE,
    logicData,
  };
}

export function sendCheckSustainability() {
  return {
    type: CHECK_SUSTAINABILITY_REQUEST,
  };
}

export function sendCheckSustainabilityOffer(offer) {
  return {
    type: CHECK_SUSTAINABILITY_OFFER_REQUEST,
    offer
  };
}

export function receiveSustainabilityResponse(responseData) {
  return {
    type: CHECK_SUSTAINABILITY_RESPONSE,
    responseData,
  };
}

export function receiveSustainabilityOfferResponse(responseData) {
  return {
    type: CHECK_SUSTAINABILITY_OFFER_RESPONSE,
    responseData,
  };
}

export function updateSustainabilitySelected(sustainabilitySelected) {
  return {
    type: SET_SUSTAINABILITY_SELECTED,
    sustainabilitySelected,
  };
}

export function resetData() {
  return {
    type: RESET_DATA,
  };
}

export function resetOfferData() {
  return {
    type: RESET_OFFER_DATA,
  };
}

export function updateProposal(params) {
  return {
    type: UPDATE_PROPOSAL,
    proposal: params,
  };
}

export function saveQuotation(params) {
  return {
    type: SAVE_QUOTATION,
    quotation: params,
  };
}

export function parsePrescoringParamsToFilters(prescoringResponse, currentSelectedParams, currentParams, contractualCategory) {
  let needFetchFilters = false;
  let qs = queryString.parse(location.search, {arrayFormat: 'comma'});

  if (prescoringResponse.monthlyRateMax > 0) {
    const currentMonthlyRate = currentSelectedParams.find(currentParam => currentParam.name === 'monthly_rate');
    let monthlyRateMin;

    if (currentMonthlyRate) {
      monthlyRateMin = currentMonthlyRate.value[0];
    } else {
      monthlyRateMin = currentParams.monthly_rates ? currentParams.monthly_rates.min : 0;
    }

    qs.monthly_rate = [monthlyRateMin, parseInt(prescoringResponse.monthlyRateMax)]
    needFetchFilters = true;
  }

  if (prescoringResponse.depositRequired === true) {
    const currentDeposit = currentSelectedParams.find(currentParam => currentParam.name === 'deposit');
    let depositMax;

    if (currentDeposit) {
      depositMax = currentDeposit.value[1];
    } else {
      depositMax = currentParams.deposits ? currentParams.deposits.max : 0;
    }

    qs.deposit = [1, depositMax]
    needFetchFilters = true;
  }

  if (prescoringResponse.chance >= 0 && (location.pathname === '/offers' || location.pathname === '/offers/') && needFetchFilters) {
    setTimeout(() => {
      location.search = queryString.stringify(qs, {arrayFormat: 'comma'});
    },
    2000);
  }
}
